import { isLocalStorageAllowed } from 'utils/stringUtils';
import _get from 'lodash/get';
import _isNumber from 'lodash/isNumber';
import _orderBy from 'lodash/orderBy';

export const getUserSavedCurrentLocation = geolocation => {
  const userCurrentLocation = isLocalStorageAllowed()
    ? localStorage.getItem('userLocation')
    : '';

  if (
    userCurrentLocation &&
    _isNumber(_get(JSON.parse(userCurrentLocation), 'userLocation.lat')) &&
    _isNumber(_get(JSON.parse(userCurrentLocation), 'userLocation.long'))
  ) {
    return JSON.parse(userCurrentLocation);
  }

  const lat = _get(geolocation, 'latitude');
  const long = _get(geolocation, 'longitude');
  if (_isNumber(lat) && _isNumber(long)) {
    const savedLocation = { userLocation: { lat, long } };
    if (isLocalStorageAllowed()) {
      localStorage.setItem('userLocation', JSON.stringify(savedLocation));
    }

    return savedLocation;
  }

  return undefined;
};

const rad = x => (x * Math.PI) / 180;

export const getDistance = (p1, p2) => {
  const R = 6378137; // Earth’s mean radius in meter
  const dLat = rad(p2.lat - p1.lat);
  const dLong = rad(p2.long - p1.long);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.lat)) *
      Math.cos(rad(p2.lat)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return (d * 0.000621).toFixed();
};

export const getSortedDataWithLocation = (data, location) => {
  const withDistanceData = data.map(item => {
    const lat = _get(location, 'userLocation.lat', _get(location, 'lat'));
    const long = _get(location, 'userLocation.long', _get(location, 'lng'));
    const distance =
      lat && long
        ? getDistance(
            { lat, long },
            {
              lat: _get(item, 'fields.location.lat'),
              long: _get(item, 'fields.location.lon'),
            },
          )
        : null;
    return {
      ...item,
      fields: {
        ...item.fields,
        distance: distance ? parseInt(distance, 10) : null,
      },
    };
  });
  const sortedByDistanceData = _orderBy(
    withDistanceData,
    ['fields.distance', 'fields.name'],
    ['asc'],
  );
  return sortedByDistanceData;
};
